import React from 'react';

const redGradient = '#dc2626';
const cardBg = '#111';
const cardBorder = '#1f1f1f';
const cardBorderSelected = 'rgba(220,38,38,0.4)';

function ArtistCard({ item, isSelected, onSelect, onEdit, onDelete, viewMode }) {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric', month: 'short', day: 'numeric'
    });
  };

  const initial = item.name?.charAt(0).toUpperCase() || 'A';

  if (viewMode === 'list') {
    return (
      <div
        className="flex items-center justify-between p-4 rounded-xl transition-all"
        style={{
          background: cardBg,
          border: `1px solid ${isSelected ? cardBorderSelected : cardBorder}`,
          boxShadow: isSelected ? '0 0 0 1px rgba(220,38,38,0.2)' : 'none'
        }}
      >
        <div className="flex items-center gap-4">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={onSelect}
            className="w-4 h-4 rounded"
            style={{ accentColor: '#dc2626' }}
          />
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-xl overflow-hidden flex-shrink-0" style={{ background: redGradient }}>
              {item.artist_image_url ? (
                <img src={item.artist_image_url} alt={item.name} className="w-full h-full object-cover"
                  onError={(e) => { e.target.style.display = 'none'; }} />
              ) : (
                <div className="w-full h-full flex items-center justify-center">
                  <span className="text-white font-black text-lg">{initial}</span>
                </div>
              )}
            </div>
            <div>
              <h3 className="font-bold text-white text-sm">{item.name}</h3>
              <div className="flex items-center gap-3 mt-0.5">
                {item.country && (
                  <span className="text-xs" style={{ color: '#9ca3af' }}>{item.country}</span>
                )}
                <span className="text-xs" style={{ color: '#6b7280' }}>Added {formatDate(item.created_at)}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={onEdit} className="px-3 py-1.5 rounded-lg text-xs font-medium text-white transition-all" style={{ background: '#1a1a1a', border: '1px solid #2a2a2a' }}>
            Edit
          </button>
          <button onClick={onDelete} className="px-3 py-1.5 rounded-lg text-xs font-medium transition-all" style={{ background: 'rgba(220,38,38,0.1)', color: '#f87171', border: '1px solid rgba(220,38,38,0.2)' }}>
            Delete
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      className="relative rounded-xl p-5 transition-all group"
      style={{
        background: cardBg,
        border: `1px solid ${isSelected ? cardBorderSelected : cardBorder}`,
        boxShadow: isSelected ? '0 0 0 1px rgba(220,38,38,0.15)' : 'none'
      }}
    >
      <div className="absolute top-3 left-3">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={onSelect}
          className="w-4 h-4 rounded"
          style={{ accentColor: '#dc2626' }}
        />
      </div>

      <div className="flex flex-col items-center text-center pt-2">
        <div className="w-20 h-20 rounded-2xl overflow-hidden mb-4 flex-shrink-0" style={{ background: redGradient }}>
          {item.artist_image_url ? (
            <img src={item.artist_image_url} alt={item.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              onError={(e) => { e.target.style.display = 'none'; }} />
          ) : (
            <div className="w-full h-full flex items-center justify-center">
              <span className="text-white font-black text-2xl">{initial}</span>
            </div>
          )}
        </div>

        <h3 className="font-black text-white text-base mb-1 leading-tight">{item.name}</h3>

        {item.country && (
          <p className="text-xs mb-2" style={{ color: '#9ca3af' }}>{item.country}</p>
        )}

        {item.bio && (
          <p className="text-xs leading-relaxed line-clamp-2 mb-3" style={{ color: '#6b7280' }}>{item.bio}</p>
        )}

        <p className="text-xs mb-5" style={{ color: '#4b5563' }}>Added {formatDate(item.created_at)}</p>

        <div className="flex gap-2 w-full">
          <button onClick={onEdit} className="flex-1 py-2 rounded-lg text-xs font-medium text-white transition-all" style={{ background: '#1a1a1a', border: '1px solid #2a2a2a' }}>
            Edit
          </button>
          <button onClick={onDelete} className="flex-1 py-2 rounded-lg text-xs font-medium transition-all" style={{ background: 'rgba(220,38,38,0.1)', color: '#f87171', border: '1px solid rgba(220,38,38,0.2)' }}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}

export default ArtistCard;